
import React from 'react';
import AIPromptAssistant from './AIPromptAssistant';
import ToolManagement from './ToolManagement';
import KnowledgeBase from './KnowledgeBase';
import { SparkIcon } from '../../../components/ui/simple-icons';
import { AvailableTool } from '../../../lib/database';

interface Step2InstructionsProps {
  formData: {
    instructions: string;
    tools: any[];
    knowledgeBase: any[];
  };
  updateFormData: (key: string, value: any) => void;
  availableTools: AvailableTool[];
  setShowPromptHelper: (show: boolean) => void;
  agentId?: string | null;
}

const Step2Instructions: React.FC<Step2InstructionsProps> = ({ formData, updateFormData, availableTools, setShowPromptHelper, agentId }) => {
  console.log('[Step2Instructions] Received Available Tools:', JSON.stringify(availableTools, null, 2));
  return (
    <div className="space-y-8">
      <div className="bg-white rounded-xl p-4 sm:p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-medium text-gray-900">Agent Instructions</h3>
          <button
            onClick={() => setShowPromptHelper(true)}
            className="hidden sm:flex items-center space-x-2 px-3 py-1.5 bg-netlify-teal text-white rounded-lg hover:bg-netlify-600 transition-colors text-sm font-medium"
          >
            <SparkIcon />
            <span>Prompt Master</span>
          </button>
        </div>
        <p className="text-gray-600 mb-6">Define how your agent should behave and respond to users.</p>
        
        <AIPromptAssistant
          value={formData.instructions}
          onChange={(value) => updateFormData('instructions', value)}
          placeholder="You are a helpful assistant that..."
          rows={12}
        />
        
        <div className="mt-4 text-sm text-gray-500">
          <p>💡 <strong>Tips:</strong></p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>Be specific about the agent's role and expertise</li>
            <li>Include any constraints or guidelines</li>
            <li>Mention the tone and style you want</li>
            <li>Right-click in the textarea and select "Transform with AI" for intelligent suggestions</li>
          </ul>
        </div>
      </div>
      
      <ToolManagement 
        selectedTools={formData.tools}
        onToolsChange={(tools) => updateFormData('tools', tools)}
        availableTools={availableTools}
        agentId={agentId}
      />
      
      <KnowledgeBase
        kbFiles={formData.knowledgeBase}
        onKbFilesChange={(files) => updateFormData('knowledgeBase', files)}
      />
    </div>
  );
};

export default Step2Instructions;
